import React from 'react';

function ForgotPasswordForm({ onSubmit, register, errors }) {
  return (
    <div>
        <div className="card-body">
            <p className="login-box-msg">You forgot your password? Here you can easily retrieve a new password.</p>
            <form onSubmit={onSubmit}>
            <div className="input-group mb-3">
                <input
                    type="email"
                    className={`form-control ${errors.business_email?.message ? 'is-invalid': ''}`}
                    placeholder="Business Email"
                    name="business_email"
                    {...register("business_email", { required: "Email is required" })}
                />
                <div className="input-group-append">
                    <div className="input-group-text">
                        <span className="fas fa-user" />
                    </div>
                </div>
                {errors.business_email && <span className="invalid-feedback">{errors.business_email.message}</span>}
            </div>
            <div className="row">
                <div className="col-12">
                    <button type="submit" className="btn btn-primary btn-block">Send OTP</button>
                </div>
            </div>
            </form>
            <p className="mt-3 mb-1">
            <a href="/login">Already have an account? Sign In</a>
            </p>
        </div>
    </div>
  );
}

export default ForgotPasswordForm;